/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type EncounterStatus =
	(typeof EncounterStatus)[keyof typeof EncounterStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EncounterStatus = {
	created: 'created',
	in_progress: 'in_progress',
	finalizing: 'finalizing',
	completed: 'completed',
	closed: 'closed',
} as const;
